module.exports = __webpack_public_path__ + "static/media/logo_usi.b758c400.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_usi.svg
// module id = 96
// module chunks = 0